import isNil from 'lodash-es/isNil';
import fromBrandEnumToLabel from './fromBrandEnumToLabel';
const useDeviceBrandName = (device) => {
    return fromBrandEnumToLabel(!isNil(device) ? device.brand : undefined);
};
export default useDeviceBrandName;
